The selected response choice identifiers for the question.

The identifiers should be populated from available response choices within `ApplicationQuestion.responseChoice` returned with question suggestions.
